import { PrivilegesLists, privilegesListsIds } from '../constants/PrivilegesConstants.js';
var defaultPrivileges = [];
var getPrivilegesList = function getPrivilegesList(state, id) {
    var _ref;
    var _state_privilegesLists;
    return (_ref = state === null || state === void 0 ? void 0 : (_state_privilegesLists = state.privilegesLists) === null || _state_privilegesLists === void 0 ? void 0 : _state_privilegesLists[id]) !== null && _ref !== void 0 ? _ref : defaultPrivileges;
};
var getUserPrivilegesList = function getUserPrivilegesList(state) {
    return getPrivilegesList(state, privilegesListsIds[PrivilegesLists.User]);
};
export var PrivilegesListSelector = {
    getPrivilegesList: getPrivilegesList,
    getUserPrivilegesList: getUserPrivilegesList
};

//# sourceMappingURL=PrivilegesListSelectors.js.map